import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StoreDataService {
    pagination = new BehaviorSubject<any>(null);

    constructor() { }

    public static ParseJsonStringToJson(data: unknown): any {
        if (!data || typeof data !== 'string') {
            return [];
        }

        try {
            const isoRegex = /ISODate\((".+?")\)/g;

            let responseData = data
                .replace(isoRegex, (_, parenGroup) => parenGroup)
                .replaceAll('"_id"', '"ItemId"');

            return JSON.parse(responseData);
        } catch (err) {
            console.error('ParseJsonStringToJson failed:', err, data);
            return [];
        }
    }

    public static ParseJsonStringToJsonToType<T>(data: unknown): T {
        if (!data || typeof data !== 'string') {
            return {} as T;
        }

        try {
            const isoRegex = /ISODate\((".+?")\)/g;

            let responseData = data
                .replace(isoRegex, (_, parenGroup) => parenGroup)
                .replaceAll('"_id"', '"ItemId"');

            return JSON.parse(responseData) as T;
        } catch (err) {
            console.error('ParseJsonStringToJsonToType failed:', err, data);
            return {} as T;
        }
    }
}
